import { jsx as _jsx } from "react/jsx-runtime";
import { Overlay, OverlayStyle } from "@faire/retailer-visitor-shared/features/MarketplaceItems/Overlay/Overlay";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import React from "react";
export var ProductTileOverlay = function(param) {
    var data = param.data;
    var isUnavailable = data.state !== IProduct.State.FOR_SALE;
    var overlayStyle = function() {
        if (isUnavailable) {
            return OverlayStyle.UNAVAILABLE;
        } else {
            return OverlayStyle.DARKENING;
        }
    };
    if (data.includeContainer) {
        return /*#__PURE__*/ _jsx("div", {
            className: "h-full w-full",
            children: /*#__PURE__*/ _jsx(Overlay, {
                overlayStyle: overlayStyle()
            })
        });
    }
    return /*#__PURE__*/ _jsx(Overlay, {
        overlayStyle: overlayStyle()
    });
};
